import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

// A second Green API instance on another WhatsApp number, switched on while
// the main number is restricted or logged out.
const WhatsAppBackup = () => {
  const [b, setB] = useState({ active: false, url: "", instance: "", has_token: false });
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(null);

  useEffect(() => {
    axios.get(`${API}/whatsapp/backup`).then((r) => setB(r.data)).catch(() => {});
  }, []);

  const save = async (active) => {
    setBusy(true);
    try {
      const r = await axios.put(`${API}/whatsapp/backup`, { ...b, active, token });
      setB(r.data);
      setToken("");
      toast.success(active ? "Now sending from the BACKUP number" : "Back on the main number");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save");
    }
    setBusy(false);
  };

  const test = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/whatsapp/backup/test`);
      setState(r.data);
    } catch (e) {
      setState({ state: e?.response?.data?.detail || "failed", ok: false });
    }
    setBusy(false);
  };

  const field = "w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-3 py-2 text-sm text-white font-mono outline-none focus:border-[#00E054]";

  return (
    <div className={`card p-4 sm:p-6 space-y-3 ${b.active ? "border border-amber-500/60" : ""}`} data-testid="whatsapp-backup">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="text-lg font-bold text-white">Backup WhatsApp number</h2>
        <span className={`text-xs px-2 py-1 rounded ${b.active ? "bg-amber-500/20 text-amber-300" : "bg-[#27272A] text-gray-400"}`}>
          {b.active ? "SENDING FROM BACKUP" : "Main number in use"}
        </span>
      </div>
      <p className="text-xs text-gray-500">
        Connect a second number in Green API (new instance → scan its QR with the backup phone), paste its details here,
        and switch to it while the main number is blocked. While on the backup, automatic payment reminders and customer
        offline alerts are paused — a new number opening chats with every customer gets banned. Replies, alerts to you
        and trade posts in the group keep working.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <input className={field} placeholder="apiUrl, e.g. https://7105.api.greenapi.com" value={b.url}
               onChange={(e) => setB({ ...b, url: e.target.value })} />
        <input className={field} placeholder="idInstance" value={b.instance}
               onChange={(e) => setB({ ...b, instance: e.target.value })} />
        <input className={field} type="password" placeholder={b.has_token ? "apiTokenInstance (saved — blank keeps it)" : "apiTokenInstance"}
               value={token} onChange={(e) => setToken(e.target.value)} />
      </div>
      <div className="flex gap-2 flex-wrap">
        <button onClick={() => save(b.active)} disabled={busy}
                className="px-3 py-2 rounded-md border border-[#27272A] text-gray-200 text-sm">Save details</button>
        <button onClick={test} disabled={busy}
                className="px-3 py-2 rounded-md border border-[#27272A] text-gray-200 text-sm">Check backup is connected</button>
        {b.active ? (
          <button onClick={() => save(false)} disabled={busy}
                  className="px-3 py-2 rounded-md bg-[#00E054] text-black text-sm font-bold">Switch back to main number</button>
        ) : (
          <button onClick={() => window.confirm("Send everything from the backup number now?") && save(true)} disabled={busy}
                  className="px-3 py-2 rounded-md bg-amber-500 text-black text-sm font-bold">Use backup number</button>
        )}
      </div>
      {state && (
        <div className={`text-xs rounded p-2 border ${state.ok ? "border-[#00E054]/40 text-[#00E054]" : "border-red-500/40 text-red-300"}`}>
          Backup instance: {state.state}{state.ok ? " — ready" : ""}
        </div>
      )}
    </div>
  );
};

export default WhatsAppBackup;
